import axiosInstance from "@/lib/axios";

export const serviceSubscriptionService = {
  getSubscriptions: async (params) => {
    const response = await axiosInstance.get("/api/v1/admin/subscriptions", { params });
    return response.data;
  },

  getSubscriptionStatistics: async () => {
    const response = await axiosInstance.get("/api/v1/admin/subscriptions/statistics");
    return response.data;
  },

  updateSubscriptionStatus: async (id, data) => {
    const response = await axiosInstance.put(`/api/v1/admin/subscriptions/${id}/status`, data);
    return response.data;
  },

  getSubscriptionById: async (id) => {
    const response = await axiosInstance.get(`/api/v1/admin/subscriptions/${id}`);
    return response.data;
  },
};
